import * as angular from 'angular';
import PublicMapBridge from './bridges/PublicMapBridge';

angular
  .module('flowingly.runner.publicmap')
  .component('publicMap', PublicMapBridge);
